import { Pipe, PipeTransform } from '@angular/core';

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { MapNomenclatureContratDto, MapNomenclatureDto } from '../../models/tre-nomenclature-dto.model';
import { NomenclaturesService } from '../../services/nomenclatures/nomenclatures-service.service';

@Pipe({
  name: 'nomenclatures',
})
export class NomenclaturesPipe implements PipeTransform {

  constructor(public nomenclaturesService: NomenclaturesService) {}

  transform(value: string, isRejeter = false): Observable<string> {
    return isRejeter
      ? this.callPipeForPopUpRejeter(value)
      : this.callPipeForFilter(value);
  }

  callPipeForFilter(value: string): Observable<string> {
    return this.nomenclaturesService.nomenclatures.pipe(
      map((data) => {
        return this.getLibellefromKey(data, value);
      })
    );
  }

  callPipeForPopUpRejeter(value: string): Observable<string> {
    return this.nomenclaturesService.nomenclaturesContrats.pipe(
      map((data) => {
        return this.getLibellefromKeyRejet(data, value);
      })
    );
  }

  public getLibellefromKey(maps: MapNomenclatureDto, input: string): string {
    let res = 'Not found';
    for (const [key, value] of Object.entries(maps)) {
      if (key.includes('habilitation')) {
        const result = value.find((v) => {
          return v.code === input;
        });

        res = result.libelle;
      }
    }
    return res;
  }

  public getLibellefromKeyRejet(maps: MapNomenclatureContratDto, input: string): string {
    let res = 'Not found';
    for (const [key, value] of Object.entries(maps)) {
      if (key.includes('rejet')) {
        const result = value.find((v) => {
          return v.code === input;
        });

        res = result.libelle;
      }
    }
    return res;
  }

}
